import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

const safeSelector = (rootState: RootState) => rootState.attendeeEventsSidebar;

export const showAttendeeEventsSidebarSelector = createSelector(
  safeSelector,
  (atteendeeEventsSidebar) => atteendeeEventsSidebar.show
);

export const currentAttendeeEventsSidebarSelector = createSelector(
  safeSelector,
  (attenedeeSidebar) => attenedeeSidebar.currentEvent
);
